import { submitV2AnalyticsEvent } from "../utils/analyticsUtils";
import { getCookieCustomerNumber, getCookieUserId } from "../utils/cookieUtils";
import { isMaxUser } from "../utils";

export const getCurrentListFromLocalStorage = () => {
  const key = `lastListInSession_${getCookieUserId()}_${getCookieCustomerNumber()}`;
  const item =
    window && window.localStorage && window.localStorage.getItem(key);

  return item ? JSON.parse(item) : null;
};

const getCartState = () => {
  const lastListInSession = getCurrentListFromLocalStorage();
  const listType = lastListInSession && lastListInSession.listType;

  switch (listType) {
    case "CART":
      return "Standard Cart";
    case "QUOTING_TOOL":
      return "Quoting Tool";
    case "QUOTES":
      return "Quotes";
    case "PRODUCT_LIST":
      return "Product Lists";
    case "ORDERS":
      return "Orders";
    case "PUNCHOUT":
      return "Punchout";
    default:
      return null;
  }
};

const generateAndStoreSearchId = (searchTerm) => {
  if (
    !(
      window &&
      window.crypto &&
      typeof window.crypto.randomUUID === "function"
    )
  ) {
    return;
  }

  const lastSearchTerm =
    window.sessionStorage && window.sessionStorage.getItem("lastSearchTerm");
  const existingSearchId =
    window.sessionStorage && window.sessionStorage.getItem("searchId");
  const isNewSearch = !existingSearchId || searchTerm !== lastSearchTerm;

  if (isNewSearch) {
    const searchId = window.crypto.randomUUID();
    window.sessionStorage.setItem("searchId", searchId);
    window.sessionStorage.setItem("lastSearchTerm", searchTerm || "");
  }
};

export const initSearchAnalytics = () => {
  const searchResultsEl = document.querySelector("#search-results");
  const searchBarMenuDisplayed =
    searchResultsEl && searchResultsEl.style.display.toLowerCase() === "block"
      ? "Yes"
      : "No";

  const searchTerm =
    window && window.location && window.location.search
      ? new URLSearchParams(window.location.search).get("query")
      : null;

  generateAndStoreSearchId(searchTerm);

  if (window && window.location && window.location.search) {
    if (searchTerm) {
      const wrapper = document.querySelector(".product-search-page-body-wrapper");
      const totalResults = wrapper ? parseInt(wrapper.dataset.totalResults, 10) : null;
      const pageSize = wrapper ? parseInt(wrapper.dataset.pageSize, 10) : null;
      const resultCount = totalResults != null && !isNaN(totalResults) ? totalResults : null;
      const pageCount = resultCount != null && pageSize ? Math.ceil(resultCount / pageSize) : null;

      submitV2AnalyticsEvent("submitProductSearch", {
        searchTerm,
        searchBarMenuDisplayed: searchBarMenuDisplayed,
        cartState: getCartState(),
        resultCount,
        pageCount,
        searchMethod: "Search bar",
      });

      document
        .querySelectorAll(".search-result__section")
        .forEach((section) => {
          const title = section
            .querySelector(".search-result__section-title")
            .textContent.trim();
          const list = section.querySelector("ul");

          list.addEventListener("click", (event) => {
            const clickedValue = event.target.textContent.trim();
            let searchMethod = "";

            if (title === "Categories") {
              searchMethod = "Categories";
            } else if (title === "Suggested search") {
              searchMethod = "Suggested search";
            } else if (title === "Related Products") {
              searchMethod = "Related products";
            }

            if (searchMethod) {
              submitV2AnalyticsEvent("submitProductSearch", {
                searchMethod,
                value: clickedValue,
              });
              console.log(
                "searchMethod: " + searchMethod + " value: " + clickedValue,
              );
            }
          });
        });

      document.body.addEventListener("click", (event) => {
        if (
          event.target.matches(".header-main__search-button--results") &&
          isMaxUser(window)
        ) {
          submitV2AnalyticsEvent("submitProductSearch", {
            searchMethod: "Show all results",
          });
        }
      });
    }
  }
};
